import Enum from "./Enum";

/** @deprecated: see slices/engine/foundation/viewport.js */
export default Enum.create( {
	XS: 599,
	SM: 959,
	MD: 1239,
	LG: 1439,
	XL: Infinity,
} );
